/*
 * @Descripttion:
 * @Author: juanjuanhui
 * @Date: 2022-07-11 15:08:01
 * @LastEditors: yangsibo
 * @LastEditTime: 2023-02-08 09:07:52
 */
import store from "@/store";
import router from "./index";
import Home from "@/views/Home";
import Router from "vue-router";

// 需要过滤掉的路由（路由白名单）
const filterRoutes = ["/login"];
router.beforeEach((to, from, next) => {
  if (!store.state.headMenuPath) {
    store.dispatch("saveHeadMenuPath", "/cooperative/management/list");
  }
  // 路由发生变化修改页面title
  if (to.meta.pageTitle) {
    document.title = `乡村振兴数字化管理平台${to.meta.pageTitle}`;
  }
  let user = window.localStorage.getItem("user");
  // 设置2天后过期,86400000是一天的毫秒数
  let time = 86400000 * 2;
  // 判断路由指向是否在需要过滤的路由地址数组里，如果在，则直接跳进页面，无需判断
  if (filterRoutes.indexOf(to.path) !== -1) {
    next();
  } else {
    if (user) {
      user = JSON.parse(user);
      const { menuList } = user;
      // 获取登入时的时间戳
      let oldTime = window.localStorage.getItem("loginTime");
      let currentTime = new Date().getTime();
      if (currentTime - oldTime >= time) {
        // 过期了,前往登入
        next({ path: "/login", query: { redirect: to.fullPath } });
      } else {
        if (router.options.routes.length == filterRoutes.length) {
          if (!menuList || menuList.length == 0) return;
          onFilterRoutes(to, next, menuList);
        } else {
          next();
        }
      }
    } else {
      next({ path: "/login", query: { redirect: to.fullPath } });
    }
  }
});

/**
 * @descripttion: 路由拼接
 * @Author: juanjuanhui
 * @Date: 2022-06-01 10:30:30
 * @param {String} view 路由地址
 * @return {*} 拼接好的路由地址
 */
const loadView = (view) => {
  const COMPONENTS = ["JobQuery/Detail"];
  if (COMPONENTS.includes(view)) {
    return () => import(`@/components/${view}`);
  } else {
    return () => import(`@/views/${view}`);
  }
};

/**
 * @descripttion: 路由过滤和跳转
 * @Author: juanjuanhui
 * @Date: 2022-06-01 10:38:43
 * @param {*} to 即将要进入的目标
 * @param {*} next
 * @param {Array} data 动态路由数据
 */
async function onFilterRoutes(to, next, data = []) {
  const routes = await filterAsyncRoutes(data, null, 1);
  let children = [];
  routes.forEach((item, index) => {
    children.push(item);
    if (index == routes.length - 1) {
      let tempRoute = {
        path: "/",
        name: "Home",
        component: Home,
        redirect: data[0] ? data[0].urlAddress : "",
        meta: {
          hidden: false,
        },
        children,
      };
        router.options.routes.push(tempRoute);
        router.matcher = new Router().matcher;
      router.addRoute(tempRoute);
    }
  });
  next({ ...to, replace: true });
}
/**
 * @descripttion: 路由过滤转换为组件对象和路径
 * @Author: juanjuanhui
 * @Date: 2022-06-01 14:42:57
 * @param {Array} data 动态路由数据
 * @return {Array} 处理好的路由数据
 */
const filterAsyncRoutes = (data, headMenuPath, level) => {
  let filterRoutes = [];
  for (let i = 0; i < data.length; i++) {
    let item = data[i];
    headMenuPath = level == 1 ? item.urlAddress : headMenuPath;
    if (item.children && item.children.length > 0) {
      onFilterChildren(item, data);
    }
    if (item.menuType == 4) {
      data.splice(i--, 1);
    }
    if (item.menuType == 3) {
      // 路由递归，转换组件对象和路径
      if (item.children && item.children.length > 0) {
        item.children = filterAsyncRoutes(item.children, headMenuPath);
      }
      item.component = loadView(item.component);
      let {
        urlAddress: path = "",
        moduleName: name,
        menuName: title,
        hideFlag: hidden,
        pullDownFlag: dropDown,
        component,
        targetPath,
        btnPermissions = [],
        showLeftFlag,
        businessType,
        redirect,
      } = item;
      let tempObj = { path, name, component, redirect };
      item.children && (tempObj.children = item.children);
      tempObj.meta = {
        title,
        icon: `${item.icon ? "iconfont " + item.icon : ""}`,
        hidden,
        dropDown,
        targetPath,
        btnPermissions,
        showLeftFlag,
        headMenuPath,
        businessType,
      };
      filterRoutes.push(tempObj);
    }
  }
  return filterRoutes;
};
/**
 * @descripttion: 过滤子级
 * 如果是按钮将按钮权限赋给其父级的btnPermissions，
 * 如果是按钮并且有对应的路由，将其作为父级的同级添加到路由表中，并且删除当前项
 * @Author: juanjuanhui
 * @Date: 2022-07-14 15:55:18
 * @param {*} item 当前项的父级
 * @param {*} data 当前项的父级所包含的子级集合
 */
const onFilterChildren = (item, data) => {
  let isTrue = false;
  item.btnPermissions = [];
  for (var j = 0; j < item.children.length; j++) {
    let val = item.children[j];
    val.targetPath = item.urlAddress;
    if (val.menuType == 4) {
      item.btnPermissions.push(val.logo);
      if (val.urlAddress && val.component) {
        val.menuType = 3;
        isTrue = data.some((v) => v.urlAddress == val.urlAddress);
        if (!isTrue) {
          data.push(val);
        }
        item.children.splice(j--, 1);
      }
    }
  }
};
